import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./tile.html";
export let TileVariants = /*#__PURE__*/function (TileVariants) {
  TileVariants["Shadow"] = "shadow";
  TileVariants["Border"] = "border";
  TileVariants["Transparent"] = "transparent";
  return TileVariants;
}({});
class Tile extends LightningElement {
  constructor(...args) {
    super(...args);
    this.grid = void 0;
    this.axis = void 0;
    this.variant = TileVariants.Shadow;
  }
  get className() {
    const classNames = `card boxing ${this.variant} `;
    return classNames;
  }
  /*LWC compiler v7.1.3*/
}
Tile.delegatesFocus = true;
_registerDecorators(Tile, {
  publicProps: {
    grid: {
      config: 0
    },
    axis: {
      config: 0
    },
    variant: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Tile, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;